<template>
  <div class="MaaSBox" @click="clickAll" v-if="rawData || errorMsg">
    <div class="outSideBox">
      <div class="contentBox">
        <div class="titleBox">
          <img
            src="https://appbkai.oss-cn-shanghai.aliyuncs.com/vue-ai-chat/v3/MaaSIcon.png"
            alt=""
            class="takeTaxiIcon"
          />
          <div class="titleTextBox">
            <div class="titleText">智能出行</div>
            <div class="titleText2" v-if="errorMsg == ''">
              为您提供以下出行方案
            </div>
          </div>
        </div>
        <div class="projectBox" :class="{ isExpire: isExpire }" v-if="rawData">
          <div
            class="projectItem"
            v-for="(value, key) in planResultArr"
            :key="key"
            @click="clickPlanItem(value)"
          >
            <!-- 单纯公交 -->
            <div class="projectItemContent" v-if="value.type == 'bus'">
              <div class="projectLine1">
                <div class="left">
                  <span class="duration">{{ calcTime(value.duration) }}</span>
                  <img
                    class="walkmanIcon"
                    src="https://appbkai.oss-cn-shanghai.aliyuncs.com/vue-ai-chat/v3/walkmanIcon.png"
                    alt=""
                  />
                  <span class="distance">{{ calcWalkDistance(value) }}</span>
                  <!-- <div class="hintBox">规避绕行</div> -->
                </div>
                <div class="right">
                  <span class="symbol">¥</span>
                  <span class="price">{{ calcPlanPrice(value) }}</span>
                </div>
              </div>
              <div class="projectLine2">
                <div
                  class="vforBox"
                  v-for="(value2, key2) in calcBusPlan(value).busArr"
                  :key="key2"
                >
                  <div class="trafficCapsule bus" v-if="value2.type == 'name'">
                    {{ value2.value }}路
                  </div>
                  <img
                    v-if="value2.type == 'cut'"
                    class="triangleIcon"
                    src="https://appbkai.oss-cn-shanghai.aliyuncs.com/vue-ai-chat/v3/triangleIcon.png"
                    alt=""
                  />
                </div>
              </div>
              <div class="projectLine3">
                <span>公交{{ calcBusPlan(value).stop_num }}站</span>
                <span class="gray" v-if="calcBusPlan(value).findOnStation">
                  •
                </span>
                <span v-if="calcBusPlan(value).findOnStation"
                  >{{ calcBusPlan(value).findOnStation }}上车</span
                >
              </div>
            </div>
            <!-- 公交+聚合打车 -->
            <div class="projectItemContent" v-if="value.type == 'jhdcBus'">
              <div class="projectLine1">
                <div class="left">
                  <span class="duration">{{ calcTime(value.duration) }}</span>
                  <img
                    class="walkmanIcon"
                    src="https://appbkai.oss-cn-shanghai.aliyuncs.com/vue-ai-chat/v3/walkmanIcon.png"
                    alt=""
                  />
                  <span class="distance">{{ calcWalkDistance(value) }}</span>
                  <div class="hintBox">规避绕行</div>
                </div>
                <div class="right">
                  <span class="symbol">¥</span>
                  <span class="price">{{ calcPlanPrice(value) }}</span>
                </div>
              </div>
              <div class="projectLine2">
                <div
                  class="vforBox"
                  v-for="(value2, key2) in calcJhdcBusPlan(value).stepArr"
                  :key="key2"
                >
                  <div
                    v-if="value2.type == 'name'"
                    class="trafficCapsule"
                    :class="{
                      bus: value2.value.type == 'bus',
                      taxi: value2.value.type == 'jhdc',
                    }"
                  >
                    {{ value2.value.name }}
                  </div>
                  <img
                    v-if="value2.type == 'cut'"
                    class="triangleIcon"
                    src="https://appbkai.oss-cn-shanghai.aliyuncs.com/vue-ai-chat/v3/triangleIcon.png"
                    alt=""
                  />
                </div>
              </div>
              <div class="projectLine3">
                <span>公交{{ calcJhdcBusPlan(value).stop_num }}站</span>
                <span class="gray" v-if="calcJhdcBusPlan(value).findOnStation">
                  •
                </span>
                <span v-if="calcJhdcBusPlan(value).findOnStation"
                  >{{ calcJhdcBusPlan(value).findOnStation }}上车</span
                >
                <span class="gray" v-if="calcJhdcBusPlan(value).findOnStation">
                  •
                </span>
                <span>{{ calcPlanPrice2(value) }}元</span>
                <span> | </span>
                <span>打车</span>
                <span>{{
                  calcDistance(calcJhdcBusPlan(value).jhdcDistance)
                }}</span>
                <span>{{ calcJhdcBusPlan(value).jhdcPrice }}元起 </span>
              </div>
            </div>
            <!-- 单纯的聚合打车 -->
            <div class="projectItemContent" v-if="value.type == 'jhdc'">
              <div class="projectLine1">
                <div class="left">
                  <span class="duration">{{ calcTime(value.duration) }}</span>
                </div>
                <div class="right">
                  <span class="symbol">¥</span>
                  <span class="price">{{ value.price }}</span>
                </div>
              </div>
              <div class="projectLine2">
                <div
                  class="vforBox"
                  v-for="(value2, key2) in calcJhdcBusPlan(value).stepArr"
                  :key="key2"
                >
                  <div
                    v-if="value2.type == 'name'"
                    class="trafficCapsule"
                    :class="{
                      bus: value2.value.type == 'bus',
                      taxi: value2.value.type == 'jhdc',
                    }"
                  >
                    {{ value2.value.name }}
                  </div>
                </div>
              </div>
              <div class="projectLine3">
                <span>聚合打车</span>
                <span>{{
                  calcDistance(calcJhdcBusPlan(value).jhdcDistance)
                }}</span>
                <span class="gray"> • </span>
                <span>{{ calcJhdcBusPlan(value).jhdcPrice }}元起 </span>
              </div>
            </div>
            <!-- 出租车 -->
            <div class="projectItemContent" v-if="value.type == 'taxi'">
              <div class="projectLine1">
                <div class="left">
                  <span class="duration">{{ calcTime(value.duration) }}</span>
                </div>
                <div class="right">
                  <span class="symbol">¥</span>
                  <span class="price">{{ value.totalPrice }}</span>
                </div>
              </div>
              <div class="projectLine2">
                <div class="vforBox">
                  <div class="trafficCapsule taxi2">
                    出租车 {{ value.totalPrice }}元起
                  </div>
                </div>
              </div>
              <div class="projectLine3">
                <span>打车</span>
                <span>{{ calcDistance(value.distance) }}</span>
                <span class="gray"> • </span>
                <span>{{ value.totalPrice }}元起 </span>
              </div>
            </div>
            <!-- 出租车 -->
            <div class="projectItemContent" v-if="value.type == 'warmCarPlan'">
              <div class="projectLine1">
                <div class="left">
                  <span class="duration">{{ calcTime(value.duration) }}</span>
                </div>
                <div class="right">
                  <span class="symbol">¥</span>
                  <span class="price">{{ value.totalPrice }}</span>
                </div>
              </div>
              <div class="projectLine2">
                <div class="vforBox">
                  <div class="trafficCapsule taxi3">
                    共享汽车 {{ value.totalPrice }}元起
                  </div>
                </div>
              </div>
              <div class="projectLine3">
                <span>租车</span>
                <span>{{ calcDistance(value.distance) }}</span>
                <span class="gray"> • </span>
                <span>{{ value.totalPrice }}元起 </span>
              </div>
            </div>
          </div>
        </div>
        <!-- 错误信息 -->
        <div
          class="errorMsgBox"
          v-if="errorMsg != ''"
          :class="{ isExpire: isExpire }"
        >
          {{ errorMsg }}
        </div>
        <div
          class="bottomBar"
          :class="{ isExpire: isExpire }"
          @click="clickMoreBtn"
        >
          <div class="moreBox">
            <div class="text">查看更多</div>
            <img
              class="right_arrow_gray"
              src="https://appbkai.oss-cn-shanghai.aliyuncs.com/vue-ai-chat/v3/right_arrow_gray.png"
              alt=""
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
const config = {
  dxlc: {
    test: "https://lzgj.test.brightcns.cn/MaaS-v2/",
    prod: "https://h5-lzgj.brightcns.com/MaaS-v2/",
  },
};
const env = process.env.VUE_APP_ENV;
export default {
  data: function () {
    return {
      isExpire: false,
      timer: null,
      rawData: null,
      bizReq: null,
      planResultArr: [],
      errorMsg: "",
    };
  },
  props: ["businessContent"],
  mounted: function () {
    console.log(this.businessContent);
    if (this.businessContent.bizCode == "SUCCESS") {
      this.rawData = JSON.parse(this.businessContent.bizData);
      this.bizReq = JSON.parse(this.businessContent.bizReq);
      console.log(this.rawData);
      this.sortPlanResult();
    } else {
      this.errorMsg = this.businessContent.bizMsg;
    }

    this.checkIsExpire(this.businessContent);
  },
  methods: {
    // 检测卡片是否过期
    checkIsExpire: function (businessContent) {
      let expireTime = new Date(
        businessContent.expireTime.replace(/-/g, "/")
      ).getTime();
      let nowTime = new Date().getTime();
      if (nowTime > expireTime) {
        this.isExpire = true;
      } else {
        console.log("卡片过期时间", expireTime - nowTime);
        this.timer = setTimeout(() => {
          this.isExpire = true;
          clearTimeout(this.timer);
          this.timer = null;
        }, expireTime - nowTime);
      }
    },
    // 点击整个卡片
    clickAll: function () {
      if (this.isExpire) {
        this.$toast("已失效");
        setTimeout(() => {
          this.jumpToH5(1);
        }, 1000);
      }
    },
    // 点击查看更多
    clickMoreBtn: function () {
      if (this.isExpire) {
        return;
      }
      // 如果有错误信息
      if (this.errorMsg != "") {
        this.jumpToH5(1);
        return;
      }
      this.jumpToH5(2);
    },
    // 点击某个具体的规划
    clickPlanItem: function (value) {
      if (this.isExpire) {
        return;
      }
      // 如果当前的类型是出租车或者是共享汽车
      console.log(value);
      if (value.type == "taxi" || value.type == "warmCarPlan") {
        this.jumpToH5(3, this.rawData.planId, value.type);
      } else {
        this.jumpToH5(3, value.sub_plan_id, value.type);
      }
    },
    // 跳到maasH5   type 1=>跳到首页  2=>跳到规划列表页  3=>跳到规划详情页
    jumpToH5: function (type, sub_plan_id, type2) {
      let url = config[this.businessContent.channel][env];
      switch (type) {
        case 1:
          url =
            url +
            `#/OutsideLoginPage?sessionId=${window.localStorage.getItem(
              "sessionId"
            )}`;
          break;
        case 2:
          url =
            url +
            `#/OutsideLoginPage?sessionId=${window.localStorage.getItem(
              "sessionId"
            )}`;
          url =
            url +
            `&departAddress=${this.bizReq.planFrom.name}&departAddressLng=${this.bizReq.planFrom.location.lng}&departAddressLat=${this.bizReq.planFrom.location.lat}&arriveAddress=${this.bizReq.planTo.name}&arriveAddressLng=${this.bizReq.planTo.location.lng}&arriveAddressLat=${this.bizReq.planTo.location.lat}`;
          break;
        case 3:
          url =
            url +
            `#/OutsideLoginPage?sessionId=${window.localStorage.getItem(
              "sessionId"
            )}&sub_plan_id=${sub_plan_id}&type=${type2}`;
          break;
      }
      console.log(url);
      // return
      window.location.href = url;
    },
    // 计算时间
    calcTime: function (value) {
      var theTime = parseInt(value); // 秒
      var middle = 0; // 分
      var hour = 0; // 小时

      if (theTime > 60) {
        middle = parseInt(theTime / 60);
        theTime = parseInt(theTime % 60);
        if (middle > 60) {
          hour = parseInt(middle / 60);
          middle = parseInt(middle % 60);
        }
      }
      var result = "";
      if (middle > 0) {
        result = "" + parseInt(middle) + "分钟" + result;
      }
      if (hour > 0) {
        result = "" + parseInt(hour) + "小时" + result;
      }
      if (middle <= 0 && hour <= 0) {
        result = "1分钟";
      }
      return result;
    },
    sortPlanResult: function () {
      let planResultArr = [];
      let planResult = this.cloneDeep(this.rawData.planResult.result);
      // 获取单纯公交方案
      let busPlanArr = planResult.routes || [];
      // 获取聚合打车+公交的方案
      let jhdcBusPlanArr = planResult.maas_routes || [];
      // 获取单纯聚合打车方案
      let jhdcPlanArr = planResult.car_routes || [];
      // 获取打车方案
      let taxiPlan = planResult.taxi || null;
      // 获取共享汽车方案
      let warmCarPlan = planResult.sharedCar || null;
      // 如果公交方案>0
      if (busPlanArr.length > 0) {
        busPlanArr[0].type = "bus";
        // 先放一个单纯公交的方案
        planResultArr.push(busPlanArr[0]);
        if (jhdcBusPlanArr.length > 0) {
          // 再放聚合打车+bus方案
          jhdcBusPlanArr[0].type = "jhdcBus";
          planResultArr.push(jhdcBusPlanArr[0]);
        }
        if (jhdcPlanArr.length > 0) {
          // 再放单纯聚合打车方案
          jhdcPlanArr[0].type = "jhdc";
          planResultArr.push(jhdcPlanArr[0]);
        }
        if (taxiPlan) {
          // 再放打车方案
          taxiPlan.type = "taxi";
          planResultArr.push(taxiPlan);
        }
        if (warmCarPlan) {
          // 再放共享汽车方案
          warmCarPlan.type = "warmCarPlan";
          planResultArr.push(warmCarPlan);
        }
        for (let i in busPlanArr) {
          if (i != 0) {
            busPlanArr[i].type = "bus";
            // 最后把剩下的纯公交方案放进去
            planResultArr.push(busPlanArr[i]);
          }
        }
      } else {
        if (jhdcBusPlanArr.length > 0) {
          // 再放聚合打车+bus方案
          jhdcBusPlanArr[0].type = "jhdcBus";
          planResultArr.push(jhdcBusPlanArr[0]);
        }
        if (jhdcPlanArr.length > 0) {
          // 再放单纯聚合打车方案
          jhdcPlanArr[0].type = "jhdc";
          planResultArr.push(jhdcPlanArr[0]);
        }
        if (taxiPlan) {
          // 再放打车方案
          taxiPlan.type = "taxi";
          planResultArr.push(taxiPlan);
        }
        if (warmCarPlan) {
          // 再放共享汽车方案
          warmCarPlan.type = "warmCarPlan";
          planResultArr.push(warmCarPlan);
        }
      }
      // 虽然这里已经排序好了，但是最终取前四条，后面的都不要了
      this.planResultArr = planResultArr.slice(0, 4);
      console.log(planResultArr);
    },
    // 传入方案 计算总体票价
    calcPlanPrice: function (plan) {
      let price = 0;
      // 市内出行
      price = plan.price;
      // console.log(price);
      return price;
    },
    // 传入方案，只计算公交票价
    calcPlanPrice2: function (plan) {
      console.log(plan);
      let price = 0;
      // 市内出行
      for (let i of plan.steps) {
        if (i[0].vehicle_info.type == 3) {
          price = price + i[0].vehicle_info.price;
        }
      }
      // console.log(price);
      return Number(price.toFixed(2));
    },
    // 传入方案，返回步行米数
    calcWalkDistance: function (plan) {
      let distance = 0;
      for (let i of plan.steps) {
        for (let j of i) {
          if (j.vehicle_info.type == 5) {
            distance = distance + j.distance;
          }
        }
      }
      if (distance > 999) {
        distance = (distance / 1000).toFixed(1) + "公里";
      } else {
        distance = distance + "米";
      }
      return distance;
    },
    // 传入方案，返回具体公交信息
    calcBusPlan: function (plan) {
      let busArr = [];
      let stop_num = 0;
      let findOnStation = false;
      for (let i of plan.steps) {
        let name = "";
        let time = 9999999;
        let num = 0;
        for (let j of i) {
          if (j.vehicle_info.type == 3) {
            name = name + j.vehicle_info.detail.name + "/";
            if (j.duration <= time) {
              num = j.vehicle_info.detail.stop_num;
              time = j.duration;
              if (findOnStation == false) {
                findOnStation = j.vehicle_info.detail.on_station;
              }
            }
          }
        }
        stop_num = stop_num + num;
        if (name != "") {
          name = name.substr(0, name.length - 1);
          busArr.push(name);
        }
      }
      if (!findOnStation) {
        findOnStation = "";
      }
      const result = [];
      for (let i = 0; i < busArr.length; i++) {
        result.push({ type: "name", value: busArr[i] });

        if (i < busArr.length - 1) {
          result.push({ type: "cut", value: null });
        }
      }
      busArr = result;
      return {
        busArr,
        stop_num,
        findOnStation,
      };
    },
    // 传入米数，返回出租车/共享汽车 公里数
    calcDistance: function (distance) {
      if (distance > 999) {
        distance = (distance / 1000).toFixed(1) + "公里";
      } else {
        distance = distance + "米";
      }
      return distance;
    },
    // 传入方案 返回公交+聚合打车信息
    calcJhdcBusPlan: function (plan) {
      let stepArr = [];
      // 公交站点数量
      let stop_num = 0;
      // 公交上车站点
      let findOnStation = false;
      // 打车公里数
      let jhdcDistance = 0;
      // 打车价格
      let jhdcPrice = 0;
      for (let i of plan.steps) {
        // 云飞处理过，这里只有 聚合打车->公交  or 公交->聚合打车的情况
        // 如果是公交
        if (i[0].vehicle_info.type == "3") {
          let obj = {
            name: i[0].vehicle_info.detail.name,
            type: "bus",
          };
          stop_num = i[0].vehicle_info.detail.stop_num;
          findOnStation = i[0].vehicle_info.detail.on_station;
          stepArr.push(obj);
        } else if (i[0].vehicle_info.type == "4") {
          let obj = {
            name: `聚合打车 ${i[0].vehicle_info.price}元起`,
            type: "jhdc",
          };
          jhdcPrice = i[0].vehicle_info.price;
          jhdcDistance = i[0].distance;
          stepArr.push(obj);
        }
      }
      const result = [];
      for (let i = 0; i < stepArr.length; i++) {
        result.push({ type: "name", value: stepArr[i] });

        if (i < stepArr.length - 1) {
          result.push({ type: "cut", value: null });
        }
      }
      stepArr = result;

      return {
        stepArr,
        stop_num,
        findOnStation,
        jhdcDistance,
        jhdcPrice,
      };
    },
  },
  destroyed: function () {
    if (this.timer) {
      clearTimeout(this.timer);
    }
  },
};
</script>

<style lang="scss" scoped>
@import "./MaaSBox.scss";
</style>
